import { connect } from "react-redux";
import CreateShiftScreen from "./CreateShiftScreen";
import { createShift } from "src/processing/redux/actions";

export default connect(
  (state) => {
    return {
      profile: state.auth.profile,
      counteragents: state.counteragents.counteragents,
      storehouse: state.storehouse.storehouse,
    };
  },
  { createShift }
)(CreateShiftScreen);
